

function reducer(state = [], action) {
    // call saga to fetch the leagues from API ?
    switch (action.type) {
        case 'SELECTED_TEAM/SET':
            return action.team;
        case 'SELECTED_TEAM/CLEAR':
            return null;
        default:
            return state;
    }
}

export default reducer;